// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1GAD1","error":"Textarea_error__1YHcL","readonly":"Textarea_readonly__3Ddcs","disabled":"Textarea_disabled__uhmHf"};